import React, { Component } from "react";
import { render } from "react-dom";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import OrderDetail from "./Components/Order/OrderDetail";
import OrderList from "./Components/Order/OrderList";
import "./app.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faWallet, faTag, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import CustomerList from "./Components/Customer/CustomerList";

import ProductList from "./Components/Product/ProductList";

import logo from "./assets/img/logo.gif";

class App extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Router>
                <div>
                    <header className="navbar sticky-top d-flex p-2 custom-nav-header navbar-light bk-light">
                        <a className="navbar-brand col-md-3 col-lg-2 me-0 px-3 custom-nav-company" href="https://dev-fame-plus.myshopify.com/admin" target="_blank">
                            <img src={logo} alt="fameaccessories" />
                        </a>
                        <ul className="navbar-nav px-3">
                            <li className="nav-item text-nowrap">
                                <a className="nav-link" href="#">
                                    Sign out
                                </a>
                            </li>
                        </ul>
                    </header>

                    {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
                    <div className="container-fluid custom-main">
                        <div className="row">
                            <nav className="main-menu">
                                <ul>
                                    <li>
                                        <a href="https://dev-fame-plus.myshopify.com/admin" target="_blank">
                                            <FontAwesomeIcon icon={faHome}/>
                                            <span className="nav-text">Home</span>
                                        </a>
                                    </li>
                                    <li className="has-subnav">
                                        <a href="/">
                                            <FontAwesomeIcon icon={faWallet}/>
                                            <span className="nav-text">Orders</span>
                                        </a>
                                    </li>
                                    <li className="has-subnav">
                                        <Link className="nav-link custom-nav-link" to="/product">
                                            <FontAwesomeIcon icon={faTag}/>
                                            <span className="nav-text">Products</span>
                                        </Link>
                                        {/* <a href="https://dev-fame-plus.myshopify.com/admin/products" target="_blank">
                                            <FontAwesomeIcon icon={faTag}/>
                                            <span className="nav-text">Products</span>
                                        </a> */}
                                    </li>
                                    <li className="has-subnav">
                                        <Link className="nav-link custom-nav-link" to="/customer">
                                            <FontAwesomeIcon icon={faUserAlt}/>
                                            <span className="nav-text">Customers</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                            <main className="col-md-9 col-lg-10 px-md-4 custom-main-sub">
                                <Switch>
                                    <Route path="/orderdetail/:id">
                                        <OrderDetail />
                                    </Route>
                                    <Route path="/customer">
                                        <CustomerList />
                                    </Route>
                                    <Route path="/product">
                                        <ProductList />
                                    </Route>
                                    <Route path="/">
                                        <OrderList />
                                    </Route>
                                </Switch>
                            </main>
                        </div>
                    </div>
                </div>
            </Router>
        );
    }
}
export default App;
const container = document.getElementById("root");
render(<App />, container);

